module.exports = __webpack_public_path__ + "static/apple-icon-144x144-1216ac35a7001f3b3cbe7a664712cf84.png";